import { IModeChooser } from "@/components/excel/schema/definiens/mode";
import {
  findModeOption,
  MultiSelector,
  SingleSelector,
} from "@/components/excel/schema/label/mode";
import { ITypeOption } from "@/components/excel/schema/definiens/bizType";

export function checkMode(value: number, chooser?: IModeChooser) {
  if (!chooser) {
    return;
  }
  const { options } = chooser;
  if (options.length && options.some((it) => it.value === value)) {
    return;
  }
  const mode = findModeOption(value);
  console.error("不支持的输入方式", value, "只支持", options);
  throw new Error(
    `不支持的输入方式:${JSON.stringify(mode)}, 只支持:${JSON.stringify(
      options
    )}`
  );
}
export function commonTransfer(
  value: number | number[],
  mode: number,
  typeText: string,
  chooser?: IModeChooser
): number[] | number[][] {
  checkMode(mode, chooser);
  if (mode === SingleSelector.value) {
    if (Array.isArray(value)) {
      const msg = `单选${typeText},期待的值应该是数字,而不是`;
      console.error(msg, value);
      throw new Error(`${msg}数组`);
    }
    return [value];
  }
  if (mode === MultiSelector.value) {
    if (!Array.isArray(value)) {
      const msg = `多选${typeText},期待的值应该是数组`;
      console.error(`${msg}, 而不是`, value);
      throw new Error(msg);
    }
    return value.map((it) => [it]);
  }
  const obj = findModeOption(mode);
  console.error("输入方式只支持单选和多选, 而不是", mode, obj);
  throw new Error(`输入方式只支持单选和多选, 而不是:${obj?.text}`);
}
export function buildCommonTransfer(option: ITypeOption) {
  return {
    [option.value]: function (
      value: number | number[],
      mode: number
    ): number[] | number[][] {
      return commonTransfer(value, mode, option.text, option.mode);
    },
  };
}
